import React from "react";

import {
  getTaxInclWithShippingTax,
  getTaxInclWithoutShippingTax,
} from "./TaxIncl";
import {
  getTaxExclWithShippingTax,
  getTaxExclWithoutShippingTax,
} from "./TaxExcl";

import pick from "lodash/pick";

export const getTaxCalculationWrapper = (record) => {
  //to call the getTaxCalculation with clean records and fake a tax profile if no tax
  const allowedKeys = [
    "orderNumber",
    "orderItems",
    "tax",
    "shippingCost",
    "contact",
    "voucher",
    "currencyCode",
    "email",
    "payments", //needed for credit
  ];

  const cleanRecord = pick(record, allowedKeys);

  const rawTax = record.tax;
  const tax = //to really make sure the tax is obj, it can be null or ""
    rawTax && typeof rawTax === "object" && Object.keys(rawTax).length > 0
      ? rawTax
      : {
          rate: 0,
          shippingRate: 0,
          itemIncludesTax: true,
          shippingIncludesTax: true, //fake a tax profile with 0% rate
        };

  return getTaxCalculation({ ...cleanRecord, tax });
};

export const getTaxCalculation = (record) => {
  const shippingRate = record.tax.shippingRate ?? record.tax.rate;
  if (record && record.tax && record.tax.itemIncludesTax) {
    const calculation = record.tax.shippingIncludesTax
      ? getTaxInclWithShippingTax({
          record,
          taxRate: record.tax.rate,
          shippingRate,
        })
      : getTaxInclWithoutShippingTax({
          record,
          taxRate: record.tax.rate,
          shippingRate,
        });
    return calculation;
  } else if (record && record.tax && !record.tax.itemIncludesTax) {
    const calculation = record.tax.shippingIncludesTax
      ? getTaxExclWithShippingTax({
          record,
          taxRate: record.tax.rate,
          shippingRate,
        })
      : getTaxExclWithoutShippingTax({
          record,
          taxRate: record.tax.rate,
          shippingRate,
        });
    return calculation;
  }
  return null;
};

export const withTaxCalculation = (WrapComp) => (props) => {
  const { record } = props;
  //itemIncludesTax defines the order is taxable and whether tax is included or excluded
  //shippingIncludesTax defines the shipping is taxable or not only
  //shippingRate will be ignored
  const calculation = getTaxCalculation(record);
  if (!calculation) {
    return null;
  }
  return <WrapComp {...props} calculation={calculation} />;
  // return <WrapComp {...props} calculation={undefined} />;
};
